<div class="page-content">



    <bd-carousel-r  class="carousel">
        <div class="carousel-item" *ngFor="let item of items">
            <div class="fake-image"></div>
            <div class="carousel-caption">
                <h5>{{item.title}}</h5>
            </div>
        </div>
    </bd-carousel-r >

    <bd-carousel-r  class="carousel2">
        <div class="carousel-item2" *ngFor="let item of items">
            <div class="content">
                <div class="fake-image"></div>
                <div class="carousel-caption">
                    <h5>{{item.title}}</h5>
                </div>
            </div>

        </div>
    </bd-carousel-r >


</div>
